export const QueryParam = {
  Page: 'page',
  PageSize: 'pageSize',
  Plant: 'plant',
  IncludeArchived: 'includeArchived',
  SortBy: 'sortBy',
  SortDir: 'sortDir',
  ReportId: 'reportId',
  Status: 'status',
  Priority: 'priority'
} as const
